// DON't forget update index.html after update types!
export const envConfig = (process.env.NODE_ENV === 'development' ? process.env : (window as any).env) as {
  SENTRY_DSN: string;
  REACT_APP_SENTRY_DSN: string;
  NODE_ENV: string;
  RELEASE_VERSION: string;
  REACT_APP_RELEASE_VERSION: string;
};
